import React from 'react';
import { Container, Row, Col } from "reactstrap";
import { T } from '../../../traks';
import { default_currency } from '../../../Site';
import { formatPrice } from '../Globals/GlobalUtils';

export const ExtraOptions = ({
  selectedExtraOption,
  setSelectedExtraOption,
  extensionTotal5,
  extensionTotal11,
  extensionNoDiscountTotal5,
  extensionNoDiscountTotal11,
}) => {
  const handleOptionClick = (value) => {
    setSelectedExtraOption(selectedExtraOption === value ? null : value);
  };

  return (
    <Container>
      <h5 className="mb-3"><T>Add‑ons</T></h5>

      <Row className='mb-2'>
        <Col>
          <label className="ad_custom_checkmark_container">
            <input
              type="radio"
              name="extra_option"
              value="1"
              checked={selectedExtraOption === "1"}
              onClick={() => handleOptionClick("1")}
              readOnly
            />
            <span className="ad_large_own_checkmark" />
          </label>
          <span><b><T>Extend premium by 5 more months for only </T></b></span>
          <span className="premium-green ad_125pct">
            <b>{formatPrice(extensionTotal5)} {default_currency}</b>
          </span>
        </Col>
      </Row>

      <Row className='mb-2'>
        <Col>
          <label className="ad_custom_checkmark_container">
            <input
              type="radio"
              name="extra_option"
              value="2"
              checked={selectedExtraOption === "2"}
              onClick={() => handleOptionClick("2")}
              readOnly
            />
            <span className="ad_large_own_checkmark" />
          </label>
          <span><b><T>Extend premium by 11 more months for only </T></b></span>
          <span className="premium-green ad_125pct">
            <b>{formatPrice(extensionTotal11)} {default_currency}</b>
          </span>
        </Col>
      </Row>
    </Container>
  );
};


// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Package/ExtraOptions.js